// import { resolve } from 'core-js/fn/promise'
import { mapState, mapActions } from 'vuex';
import nation from '../views/student/stuApply/nation';
import state from '../common/state.js';
import province from '../common/province.js';
import citys from '../views/baseSet/examSite/citys';
import { politics } from "../common/variable";
import footerList from './footerPageList';
import { getLevelList } from '@/http/modules/baseSet/majorCourse';
import { getCurrentTime } from '@/http/modules/student/userConfig';
export default {
    data() {
        return {
            showFooterPage: footerList,
            timer: null
        }
    },
    computed: {
        ...mapState('custom', ['getUserExtInfoStore']),
        ...mapState('currentPlan', ['currentPlanFromStore']),
        ...mapState('selectOptions', ['selectSchoolFromStore', 'selectStationFromStore', 'selectSubjectFromStore', 'selectPlanFromStore', 'selectExamSignFromStore']),
        ...mapState('systemConfig', ['systemConfigFromStore']),
        ...mapState('permission', ['commonInfoFromStore'])
    },
    methods: {
        ...mapActions('custom', ['getUserExtInfoAction']),
        ...mapActions('currentPlan', ['getCurrentPlanAction']),
        ...mapActions('selectOptions', ['getSelectSchoolAction', 'getSelectStationAction', 'getSelectSubjectAction', 'getSelectPlanAction', 'getSelectExamSignAction']),
        ...mapActions('systemConfig', ['getSystemConfigAction']),
        ...mapActions('permission', ['getCommonInfoAction']),
        ...mapActions('permission', ['resetRoutesAction']),
        clearTimer() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
        },
        //全局批次获取
        getCurrentGlobalPlanId() {
            return sessionStorage.getItem('planId') || ''
        },
        //点击图片放大效果

        lookBigImage(img) {
            const image = new Image();
            image.src = img;
            image.onload = () => {
                // 创建弹出层
                const previewContainer = document.createElement('div');
                previewContainer.style.position = 'fixed';
                previewContainer.style.zIndex = '9999';
                previewContainer.style.top = 0;
                previewContainer.style.bottom = 0;
                previewContainer.style.left = 0;
                previewContainer.style.right = 0;
                previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
                previewContainer.style.display = 'flex';
                previewContainer.style.justifyContent = 'center';
                previewContainer.style.alignItems = 'center';
                document.body.appendChild(previewContainer);
                // 在弹出层中添加图片
                const previewImage = document.createElement('img');
                previewImage.src = img;
                previewImage.style.maxWidth = '80%';
                previewImage.style.maxHeight = '80%';
                previewContainer.appendChild(previewImage);
                // 点击弹出层，关闭预览
                previewContainer.addEventListener('click', () => {
                    document.body.removeChild(previewContainer);
                });
            };
        },

        /****************************
         * @returns 考生自定义字段信息处理
         ****************************/
        async mixin_setUserExtInfo() {
            let data = await this.mixin_getUserExtInfo();
            let subject = await this.getSubject();
            let level = await this.getLevel();
            // 系统配置项
            let customForm = { realName: '', cardType: '', cardNo: '', sex: '', phone: '', schoolId: '', stationId: '', courseId: '', photo: '', photoDefault: '', placeId: '' };
            // 表单校验
            let customRules = {};
            // select 搜索配置
            let requestForm = {};
            // table 配置
            data.map((e, i) => {
                customForm[e.name] = '';
                customRules[e.name] = [{ required: e.required == 1, message: "请输入" + e.displayName, trigger: 'blur' }];
                if (e.type == "text" || e.type == "textarea") {
                    customRules[e.name].push({ min: e.minSize, max: e.maxSize, message: `长度在 ${e.minSize} ~ ${e.maxSize} 之间`, trigger: 'blur' });
                }
                if (e.queryCondition == 1) {
                    requestForm[e.name] = '';
                }
                if ((e.type == 'select' && e.valueVo)) {
                    e.valueVo.forEach((item, key) => {
                        if (item.name) {
                            return false;
                        } else {
                            e.valueVo[key] = { 'name': item };
                        }
                    });
                } else if (e.type == 'select' && e.relationValue) {
                    if (e.relationValue == "province") {
                        e.valueVo = {};
                        e.valueVo = province;
                    } else if (e.relationValue == "state") {
                        e.valueVo = {};
                        e.valueVo = state;
                    } else if (e.relationValue == "nation") {
                        e.valueVo = {};
                        e.valueVo = nation;
                    } else if (e.relationValue == "city") {
                        e.valueVo = {};
                        e.valueVo = province
                    } else if (e.relationValue == "politics") {
                        e.valueVo = {};
                        e.valueVo = politics
                    }
                } else if (e.type == "provinceCity") {
                    e.valueVo = {};
                    e.valueVo = citys;
                } else if (e.type == "subject") {
                    e.valueVo = {};
                    e.valueVo = subject.data;
                } else if (e.type == "politicalStatus") {
                    e.valueVo = {};
                    e.valueVo = politics;
                } else if (e.type == "nation") {
                    e.valueVo = {};
                    e.valueVo = nation;
                } else if (e.type == "province") {
                    e.valueVo = {};
                    e.valueVo = province;
                } else if (e.type == "level") {
                    e.valueVo = {};
                    e.valueVo = level;
                }
            });
            return { data, customForm, customRules, requestForm };
        },

        /****************************** 
         * @returns 专业
         ******************************/
        getSubject() {
            return new Promise(async (resolve) => {
                let data = await this.$api.applyManage.queryAllSubject({ state: 1 });
                resolve(data)
            })
        },

        /****************************** 
         * @returns 当前时间
         ******************************/
        mixin_getServerTime() {
            return new Promise(async (resolve) => {
                let data = await getCurrentTime({ state: 1 });
                resolve(data)
            });
        },

        /****************************** 
         * @returns 层次
         ******************************/
        getLevel() {
            return new Promise(async (resolve) => {
                let data = await getLevelList()
                resolve(data.data)
            });
        },

        /****************************
         * @returns 考生的自定义字段信息
         ****************************/
        mixin_getUserExtInfo() {
            return new Promise(async (resolve) => {
                if (Object.keys(this.getUserExtInfoStore).length) {
                    resolve(this.getUserExtInfoStore)
                } else {
                    let data = await this.getUserExtInfoAction()
                    resolve(data)
                }
            })
        },

        /****************************
         * @returns 获取当前批次信息
         ****************************/
        mixin_getCurrentlanInfo() {
            return new PrPomise(async (resolve) => {
                if (Object.keys(this.currentPlanFromStore).length) {
                    resolve(this.currentPlanFromStore)
                } else {
                    let data = await this.getCurrentPlanAction()
                    resolve(data)
                   
                }
            })
        },

        /****************************
         * @returns 修改当前批次信息
         ****************************/
        mixin_updateCurrentPlanInfo() {
            this.getCurrentPlanAction()
        },

        /****************************
         * @returns 所有的院校列表
         ****************************/
        mixin_getSelectSchool() {
            return new Promise(async (resolve) => {
                if (this.selectSchoolFromStore.length) {
                    resolve(this.selectSchoolFromStore)
                } else {
                    let data = await this.getSelectSchoolAction()
                    resolve(data)
                }
            })
        },

        /*****************************
         * @returns 所有的教学点列表
         *****************************/
        mixin_getSelectStation() {
            return new Promise(async (resolve) => {
                if (this.selectStationFromStore.length) {
                    resolve(this.selectStationFromStore)
                } else {
                    let data = await this.getSelectStationAction()
                    resolve(data)
                }
            })
        },

        mixin_getSelectSubject() {
            return new Promise(async (resolve) => {
                if (this.selectSubjectFromStore.length) {
                    resolve(this.selectSubjectFromStore)
                } else {
                    let data = await this.getSelectSubjectAction()
                    resolve(data)
                }
            })
        },

        /****************************
         * @returns 获取所有批次
         ****************************/
        mixin_getSelectPlan() {
            return new Promise(async (resolve) => {
                if (this.selectPlanFromStore.length) {
                    resolve(this.selectPlanFromStore)
                } else {
                    let data = await this.getSelectPlanAction()
                    resolve(data)
                }
            })
        },

        mixin_getSelectExamSign() {
            return new Promise(async (resolve) => {
                if (this.selectExamSignFromStore.length) {
                    resolve(this.selectExamSignFromStore)
                } else {
                    let data = await this.getSelectExamSignAction()
                    resolve(data)
                }
            })
        },

        mixin_getSystemConfig() {
            return new Promise(async (resolve) => {
                if (Object.keys(this.systemConfigFromStore).length) {
                    resolve(this.systemConfigFromStore)
                } else {
                    let data = await this.getSystemConfigAction();
                    resolve(data)
                }
            })
        },

        // mixin_updateSystemConfig () {
        //     this.getSystemConfigAction()
        // },

        mixin_dealParamsWithArray(obj) {
            let params = { ...obj }
            for (let item in params) {
                if (Array.isArray(params[item])) {
                    delete params[item]
                }
            }
            return params
        },

        /******************************
         * @returns 读取到的用户权限
         ******************************/
        mixin_getCommonInfo() {
            return new Promise(async (resolve) => {
                if (Object.keys(this.commonInfoFromStore).length) {
                    resolve(this.commonInfoFromStore)
                } else {
                    let data = await this.getCommonInfoAction()
                    resolve(data)
                }
            })
        },
        /******************************
         * @returns 退出登录
         ******************************/
        mixin_outLogin() {
            this.$api.login.outLogin().then(res => {
                if (res.code) {
                    window.localStorage.removeItem('userInfo')
                    console.log('刷新啦')
                    // 这块用刷新跳登录页面  来重置路由表
                    location.reload()
                    // this.$router.replace({name:'Login',query:{'tenant':tenant}})
                    // 重置动态路由为空
                    // this.resetRoutesAction()
                    // 退出登录 不让点击浏览器的返回按钮吧
                    history.pushState(null, null, document.URL);
                    window.addEventListener('popstate', function () {
                        history.pushState(null, null, document.URL);
                    })
                }
            })

        },

    },
}
